const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

export const shouldShowProcessingState = (
  hardMatchCount: number,
  userProfileUpdatedAt?: string | null,
  now = Date.now(),
) =>
  hardMatchCount === 0 &&
  (!userProfileUpdatedAt ||
    now - new Date(userProfileUpdatedAt).getTime() < FIFTEEN_MINUTES_MS);
